module.exports = __webpack_public_path__ + "img/课程数量.fcbe86d1.svg";